import { render, staticRenderFns } from "./LossApply.vue?vue&type=template&id=791be7aa&scoped=true&"
import script from "./LossApply.vue?vue&type=script&lang=js&"
export * from "./LossApply.vue?vue&type=script&lang=js&"
import style0 from "./LossApply.vue?vue&type=style&index=0&id=791be7aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791be7aa",
  null
  
)

export default component.exports